import React, { memo, useMemo } from 'react';
import PayeeSelector from '@shared/components/PayeeSelector';

const PayContact = ({ isBuy, formik, payee }) => {
  const pointOfSaleMessage = useMemo(() => {
    if (!payee.subsidiary) return '';
    const day = '24 horas';
    return !isBuy ? (
      <>
        Deberá acercarse a la sucursal de {payee.subsidiary.name} seleccionada
        para finalizar el proceso de compra, que incluye el pago, la emisión y
        la entrega del voucher. En caso de no confirmar el pago, la reserva se
        cancelará automáticamente dentro de {day}.
      </>
    ) : (
      <>
        Para cualquier consulta, comunicarse con la sucursal{' '}
        {payee.subsidiary.name} seleccionada
      </>
    );
  }, [payee.subsidiary, isBuy]);

  return (
    <PayeeSelector
      payee={payee}
      formik={formik}
      pointOfSaleMessage={pointOfSaleMessage}
    />
  );
};

export default memo(PayContact);
